import {Component} from "@angular/core";

@Component({
    selector: 'view',
    template: '<router-outlet></router-outlet>'
})
export class OutletComponent {

    constructor() {
    }

}



// WEBPACK FOOTER //
// ./src/app/core/view.component.ts